<template>
  <div class="regra-coalesce">
    <div class="bloco-label">Use o primeiro valor preenchido entre os campos abaixo</div>
    <div class="info">A ordem importa: o primeiro campo com valor não nulo e não vazio será enviado.</div>

    <div v-for="(caminho, idx) in regra.campos" :key="idx" class="campo-linha">
      <span class="ordem">#{{ idx + 1 }}</span>
      <select class="form-control form-control-sm" :value="caminho" @change="alterar(idx, $event.target.value)">
        <option value="">Selecione um campo</option>
        <option v-for="c in campos" :key="c.value" :value="c.value">{{ c.label }}</option>
      </select>
      <button
        type="button"
        class="btn-mini btn-mini--danger"
        v-if="regra.campos.length > 1"
        @click="remover(idx)"
        title="Remover"
      >
        <fa-icon icon="trash-alt" />
      </button>
    </div>

    <button type="button" class="btn-add-inline" @click="adicionar">
      <fa-icon icon="plus" /> Adicionar campo
    </button>
  </div>
</template>

<script>
export const regraCoalesceVazia = () => ({ tipo: "coalesce", campos: [""] });

export default {
  name: "RegraCoalesce",
  props: {
    value: { type: Object, required: true },
    campos: { type: Array, default: () => [] },
  },
  computed: {
    regra() {
      return this.value;
    },
  },
  methods: {
    emit() {
      this.$emit("input", { ...this.regra });
    },
    adicionar() {
      this.regra.campos.push("");
      this.emit();
    },
    remover(idx) {
      this.regra.campos.splice(idx, 1);
      this.emit();
    },
    alterar(idx, valor) {
      this.$set(this.regra.campos, idx, valor);
      this.emit();
    },
  },
};
</script>

<style scoped>
.regra-coalesce { display: flex; flex-direction: column; gap: 6px; }
.bloco-label {
  font-size: 11px; font-weight: 600; color: #667085;
  text-transform: uppercase; letter-spacing: 0.3px;
}
.info { font-size: 12px; color: #98a2b3; margin-bottom: 6px; }
.campo-linha {
  display: flex; align-items: center; gap: 8px;
}
.ordem {
  font-size: 11px; font-weight: 600; color: #667085;
  background: #e9ecef; padding: 1px 6px; border-radius: 4px;
}
.btn-add-inline {
  background: none; border: none; color: #3a3e81;
  font-size: 12px; padding: 4px 0;
  cursor: pointer; align-self: flex-start; margin-top: 4px;
}
.btn-add-inline:hover { text-decoration: underline; }
.btn-mini {
  background: none; border: none; cursor: pointer; color: #98a2b3;
  padding: 2px 6px; border-radius: 4px;
}
.btn-mini--danger:hover { color: #d92d20; background: #fef3f2; }
</style>
